import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import BottomStatusFilter from '@spark/ui-components/components/BottomStatusFilter';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import PainelDisponibilidadeMotorista from './components/PainelDisponibilidadeMotorista';
import PainelDisponibilidadeFrota from './components/PainelDisponibilidadeFrota';
import PosicoesFrotaMap from './components/PosicoesFrotaMap';
import { ApiRefreshIndicator } from './components/RefreshIndicator';
import { getFilterConfigFrotaTracao, getFilterConfigFrotaReboque } from './config/filterConfigFrota';
import { useDisponibilidadeFrotaPatioController } from './hooks/useDisponibilidadeFrotaPatioController';
import { TopActions, TopActionsRow } from './DisponibilidadeFrota-styled';

const enableMapaPosicoes = true;

const DisponibilidadeFrotaPatio = () => {
  const {
    dadosDisponibilidade,
    apiLoading,
    shouldShowApiLoading,
    lastUpdatedAt,
    handleApiRefresh,
    categoriaAtiva,
    setCategoriaAtiva,
    resetFiltrosCategoriaToken,
    handleCategoriaAtivaChange,
    selecaoAtiva,
    handleToggleSelection,
    selectedMapRegion,
    handleMapRegionChange,
    selectedMapFrotaSearch,
    handleMapFrotaSearchChange,
    positionRefreshCountdownMs,
    positionLastUpdatedAt,
    positionRefreshPaused,
    positionLoading,
    handlePositionRefresh,
    handleTogglePositionRefreshPaused,
    mapaPosicoesFrotas,
    handlePosicaoLoaded,
    handleVisibleTracaoItemsChange,
    frotasTracaoFiltradas,
    frotasReboqueFiltradas,
    categoriaDisponivelFilterOverridesTracao,
    categoriaDisponivelFilterOverridesReboque
  } = useDisponibilidadeFrotaPatioController({
    enableMap: enableMapaPosicoes
  });

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              {
                name: 'Início'
              },
              {
                name: 'Disponibilidade Frota Pátio'
              }
            ]}
          />
        </Col>
      </Row>

      <Card height="auto">
        <CardBody>
          <TopActionsRow className="mb-4">
            <Col md={12}>
              <TopActions>
                <ApiRefreshIndicator
                  enabled={true}
                  onRefresh={handleApiRefresh}
                  loading={apiLoading}
                  lastUpdatedAt={lastUpdatedAt}
                />
              </TopActions>
            </Col>
          </TopActionsRow>

          <Row className="mb-4">
            <Col md={12}>
              <BottomStatusFilter
                options={dadosDisponibilidade.resumoFrotas.map(item => ({
                  value: item.id,
                  label: item.label,
                  icon: item.icon,
                  count: item.quantidadeDisponivel,
                  summaryLines: [
                    `Quantidade disponivel: ${item.quantidadeDisponivel}`,
                    `Quantidade indisponivel: ${item.quantidadeIndisponivel}`,
                    `Quantidade total: ${item.quantidadeTotal}`
                  ]
                }))}
                value={categoriaAtiva || ''}
                onChange={handleCategoriaAtivaChange}
              />
            </Col>
          </Row>

          <Row>
            <Col xl={4} lg={4} md={12}>
              <PainelDisponibilidadeMotorista
                titulo="Disponibilidade Motorista"
                tituloFiltro="Filtros de Motorista"
                tipo="motorista"
                exportFileName="disponibilidade-motorista.xlsx"
                sheetName="Motoristas"
                data={dadosDisponibilidade.motoristas}
                loading={shouldShowApiLoading}
                selecaoAtiva={selecaoAtiva}
                onToggleSelection={handleToggleSelection}
              />
            </Col>

            <Col xl={4} lg={4} md={12} className="mt-4 mt-lg-0">
              <PainelDisponibilidadeFrota
                titulo="Disponibilidade Frota Tração"
                tituloFiltro="Filtros de Frota Tração"
                tipo="tracao"
                exportFileName="disponibilidade-frota-tracao.xlsx"
                sheetName="Frota Tracao"
                data={frotasTracaoFiltradas}
                optionsData={dadosDisponibilidade.frotasTracao}
                loading={shouldShowApiLoading}
                filters={getFilterConfigFrotaTracao}
                filterOverrides={categoriaDisponivelFilterOverridesTracao}
                resetFiltrosToken={resetFiltrosCategoriaToken}
                selecaoAtiva={selecaoAtiva}
                onToggleSelection={handleToggleSelection}
                onSyncCategoriaAtiva={setCategoriaAtiva}
                posicoesPorChave={dadosDisponibilidade.posicoesPorChave}
                onPosicaoLoaded={handlePosicaoLoaded}
                onVisiblePageItemsChange={handleVisibleTracaoItemsChange}
              />
            </Col>

            <Col xl={4} lg={4} md={12} className="mt-4 mt-lg-0">
              <PainelDisponibilidadeFrota
                titulo="Disponibilidade Frota Reboque"
                tituloFiltro="Filtros de Frota Reboque"
                tipo="reboque"
                exportFileName="disponibilidade-frota-reboque.xlsx"
                sheetName="Frota Reboque"
                data={frotasReboqueFiltradas}
                optionsData={dadosDisponibilidade.frotasReboque}
                loading={shouldShowApiLoading}
                filters={getFilterConfigFrotaReboque}
                filterOverrides={categoriaDisponivelFilterOverridesReboque}
                resetFiltrosToken={resetFiltrosCategoriaToken}
                selecaoAtiva={selecaoAtiva}
                onToggleSelection={handleToggleSelection}
                onSyncCategoriaAtiva={setCategoriaAtiva}
              />
            </Col>
          </Row>
          {enableMapaPosicoes ? (
            <Row className="mt-4">
              <Col md={12}>
                <PosicoesFrotaMap
                  allVehicles={mapaPosicoesFrotas.allItems}
                  vehicles={mapaPosicoesFrotas.vehicles}
                  foundCount={mapaPosicoesFrotas.foundCount}
                  loadingCount={mapaPosicoesFrotas.loadingCount}
                  missingCount={mapaPosicoesFrotas.missingCount}
                  nextRefreshInMs={positionRefreshCountdownMs}
                  positionLastUpdatedAt={positionLastUpdatedAt}
                  positionRefreshPaused={positionRefreshPaused}
                  positionLoading={positionLoading}
                  onPositionRefresh={handlePositionRefresh}
                  onTogglePositionRefreshPaused={handleTogglePositionRefreshPaused}
                  regionOptions={mapaPosicoesFrotas.regionOptions}
                  frotaOptions={mapaPosicoesFrotas.frotaOptions}
                  selectedRegion={selectedMapRegion}
                  onRegionChange={handleMapRegionChange}
                  selectedFrotaSearch={selectedMapFrotaSearch}
                  onFrotaSearchChange={handleMapFrotaSearchChange}
                />
              </Col>
            </Row>
          ) : null}
        </CardBody>
      </Card>
    </Container>
  );
};

export default DisponibilidadeFrotaPatio;
